export const defaultSidebarMenuConfig = [
    {
        label: "Placement Portal",
        items: [
            {
                menuKey: "profile",
                menuTitle: "My Profile",
                menuIcon: "lucide:user",
                navigationPath: "/profile",
            },
            {
                menuKey: "company-list",
                menuTitle: "Company List",
                menuIcon: "lucide:building-2",
                navigationPath: "/company-list",
            },
            {
                menuKey: "placement-management",
                menuTitle: "Placement Management",
                menuIcon: "lucide:briefcase-business",
                navigationPath: "/placement-management",
            },
            {
                menuKey: "student-view",
                menuTitle: "Student View",
                menuIcon: "lucide:users",
                navigationPath: "/student-view",
            },
            {
                menuKey: "job-opportunities",
                menuTitle: "View Placement Details",
                menuIcon: "lucide:list-checks",
                navigationPath: "/job-opportunities",
            },
            {
                menuKey: "my-applications",
                menuTitle: "My Applications",
                menuIcon: "lucide:git-commit-horizontal",
                navigationPath: "/my-applications",
            },
            {
                menuKey: "settings",
                menuTitle: "Settings",
                menuIcon: "lucide:settings",
                navigationPath: "/settings",
            }
        ],
    }
];
